import React, { FC } from 'react';
import { Route, Switch, matchPath, useLocation } from 'react-router-dom';
import { COMPANY_PUBLIC_PROFILE_ROUTE, COMPANY_PROFILE_ROUTE, COMPANY_REVIEWS_ROUTE } from '@src/Routes/links';
import { useSessionQuery } from '@src/graphql/generated';
import CompanyForm from './PublicProfile';
import { Reviews } from './Reviews';
import { Header } from './Header';

export const Company: FC = () => {
  const location = useLocation();

  const { data } = useSessionQuery();

  const matchCompanyProfile = matchPath<{ companyProfileId: string }>(location.pathname, {
    path: COMPANY_PROFILE_ROUTE,
  });
  const matchCompanyPublicProfile = matchPath<{ companyProfileId: string }>(location.pathname, {
    path: COMPANY_PUBLIC_PROFILE_ROUTE,
  });

  return (
    <div>
      <Header companyProfileId={data?.company.profile.id} location={location} />

      <Switch>
        <Route exact path={COMPANY_PROFILE_ROUTE}>
          <CompanyForm companyProfileId={matchCompanyProfile?.params.companyProfileId} />
        </Route>

        <Route exact path={COMPANY_PUBLIC_PROFILE_ROUTE}>
          <CompanyForm companyProfileId={matchCompanyPublicProfile?.params.companyProfileId} />
        </Route>

        <Route exact path={COMPANY_REVIEWS_ROUTE}>
          <Reviews />
        </Route>
      </Switch>
    </div>
  );
};
